import { getDeleteWorkflowButton } from './get-delete-workflow-button'

export default getDeleteWorkflowButton
